import { defineMessages } from 'react-intl';

const messages = defineMessages({
  Resource: 'Resource',
  CopyPriceGrid: 'Copy price grid',
  CreatePriceGrid: 'Create price grid',
  ChangePriceGridName: 'Change name',
  Name: 'Name',
  DeletePriceGrid: 'Delete price grid?',
  DeletePriceGridConfirmationMsg: 'Are u sure you want to delete this price grid?',
  Default: 'Default',
  MakeDefaultPriceGrid: 'Make default for new relations',
  UpdateAmount: 'Update amount',
  Method: 'Method',
  Percentage: 'Percentage',
  Amount: 'Amount',
  PriceProfile: 'Price profile',
  All: 'All',
  AllProfiles: 'All profiles',
  AllUsers: 'All users',
  AllCompanies: 'All companies',
  AllPriceGrids: 'All price grids',
  WarningAllPriceGrids: 'This operation will update all price grids in your environment',
  CurrentPriceGrid: 'Current price grid',
  AllResources: 'All resources',
  ResourceCategory: 'ResourceCategory',
  PriceGrid: 'Price grid',
  User: 'User',
  Relation: 'Relation',
  OwnCompany: 'Own company',
  RegistrationDateFrom: 'Registration date from',
  RecalculateRegistrationPrices: 'Recalculate registration prices',
  XRegistrationsWillBeUpdated: '{x} registrations will be updated by this action',
  PriceGridGlobalActionsTooltip: 'Please select one or more price grids.',
  OverrideManuallyChangedPrices: 'Override manually changed prices',
  RecalcRegistrationPriceJobQueued:
    'The price of registrations matching the criteria will be recalculated in the background. Click here to view its progress.',
  ChangesSaved: 'Changes saved',
  RoundingMethod: 'Rounding method',
  RoundTo: 'Round to',
  Digits: 'Digits',
  Example: 'Example',
  ExportToExcel: 'Export to Excel',
  ExportToExcelStarted: 'Export to Excel started',
  BackgroundJobQueued: 'A background job has started. Click here to monitor the progress.',
});

export default messages;
